/* eslint-disable */
import axios from 'axios';
import store from '@/store';
import { refreshToken } from '@/methods/auth';
import { getErrorMessage } from '@/compositions/helpers/helpers';
import { ElNotification } from 'element-plus';

axios.defaults.withCredentials = true;

export const loginApiInstance = axios.create({
  baseURL: window.APP_CONFIG.VUE_APP_API_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

// Промис текущего рефреша токена, а не булев флаг: запросы, упавшие с 401 пока рефреш уже
// идёт, должны дождаться именно ЕГО результата, а не пропускать ожидание и сразу повторять
// запрос со старым токеном. Сбрасывается в null по завершении — иначе рефреш срабатывает
// только один раз за сессию, а при всех следующих протуханиях токена не вызывается вовсе.
let refreshTokenPromise = null;

const defaultConfig = {
  baseURL: window.APP_CONFIG.VUE_APP_API_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
};

export const defaultApiInstance = axios.create(defaultConfig);

defaultApiInstance.interceptors.request.use(
  function (defaultConfig) {
    const token = localStorage.getItem('token');
    if (token) defaultConfig.headers['X-AUTH-TOKEN'] = `${token}`;

    return defaultConfig;
  },
  function (error) {
    return Promise.reject(error);
  }
);

defaultApiInstance.interceptors.response.use(
  (response) => {
    if (typeof response.data === 'object' && 'status' in response.data && !response.data?.status) {
      ElNotification.error({
        dangerouslyUseHTMLString: true,
        message: getErrorMessage(response.data),
        duration: 10000,
      });
    }

    return response;
  },
  async (error) => {
    const defaultConfig = error.config;

    if (error.response) {
      if (error.response.status === 401 && !defaultConfig._retry) {
        defaultConfig._retry = true;

        try {
          if (!refreshTokenPromise) {
            refreshTokenPromise = refreshToken({
              refreshToken: localStorage.getItem('refreshToken'),
            })
              .then((rs) => {
                store.commit('auth/UPDATE_TOKEN', rs.data.data.token);
                store.commit('auth/UPDATE_REFRESH_TOKEN', rs.data.data.refreshToken);
              })
              .finally(() => {
                refreshTokenPromise = null;
              });
          }

          await refreshTokenPromise;

          return defaultApiInstance(defaultConfig);
        } catch (_error) {
          await store.dispatch('auth/logout');
        }
      }

      if (error.response.status === 404 && !defaultConfig._retry) {
        defaultConfig._retry = true;
        location.href = '/404';
      }
    }

    return Promise.reject(error);
  }
);
